var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abow_wbox bkf7"},[_c('div',{staticClass:"inter"},[_c('div',{staticClass:"de_content_box"},[_c('div',{staticClass:"content_nbox"},[_c('div',{staticClass:"show_new_nox"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.info.archivesInfo.content)}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }